import React from 'react';
import AsyncPage from './async';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';

export default [
  <DefaultBusinessLayout
    key="/business/user/reset-password"
    exact
    path="/business/user/reset-password"
    component={AsyncPage}
  />,
];
